import React from 'react';
import { Link } from 'react-router-dom';

const RelatedArticles = ({ articles }) => {
  if (!articles || articles.length === 0) return null;

  return (
    <section>
      <h2 className="text-xl font-semibold mb-4">Articles similaires</h2>
      <ul className="space-y-3">
        {articles.map((article) => (
          <li key={article.ID}>
            <Link
              to={`/article/${article.slug}`}
              className="text-blue-600 hover:underline"
            >
              {article.title}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default RelatedArticles;
